module.exports = __webpack_public_path__ + "media/audio19.36733242.mp3";